import React from 'react';
import './DeleteEventPopup.css';
import warningIcon from '../../../assets/images/warning_icon.png';

const DeleteEventPopup = ({ event, isVisible, onClose, onConfirm }) => {
  if (!isVisible) return null;

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="delete-popup-overlay">
      <div className="delete-popup-content">
        <img src={warningIcon} alt="Warning" className="warning-icon" />
        <h2>Delete Event</h2>
        <p>Are you sure you want to delete this event?</p>
        
        <div className="event-details">
          <div className="detail-row">
            <span className="label">Event ID:</span>
            <span className="value">{event.id}</span>
          </div>
          <div className="detail-row">
            <span className="label">Name:</span>
            <span className="value">{event.name}</span>
          </div>
          <div className="detail-row">
            <span className="label">Exam Name:</span>
            <span className="value">{event.exam_name || "N/A"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Level:</span>
            <span className="value">{event.level}</span>
          </div>
          <div className="detail-row">
            <span className="label">Round:</span>
            <span className="value">{event.round}</span>
          </div>
          <div className="detail-row">
            <span className="label">Start:</span>
            <span className="value">{formatDateTime(event.start_date_time)}</span>
          </div>
          <div className="detail-row">
            <span className="label">End:</span>
            <span className="value">{formatDateTime(event.end_date_time)}</span>
          </div>
        </div>

        <div className="button-container">
          <button className="cancel-btn" onClick={onClose}>No</button>
          <button className="confirm-btn" onClick={() => onConfirm(event.id)}>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEventPopup;
